<template>
  <div id="polar-chart"></div>
</template>

<script>
import ApexCharts from 'apexcharts'
export default {
  name: "PolarChart",
  data() {
    return {
      options : {
        series: [14, 23, 21, 17, 15, 10, 12],
        chart: {

          type: 'polarArea',
        },
        labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        stroke: {
          colors: ['#fff']
        },
        fill: {
          opacity: 0.8
        },
        legend: {
          show: true,
          position: 'bottom'
        },

      }
    }
  },
  mounted() {
    let chart = new ApexCharts(document.querySelector("#polar-chart"), this.options);
    chart.render();
  }
}
</script>

<style scoped>

</style>